import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { VestingTypeEnum } from 'constants/vesting'
import { VestingProvider } from 'context/vesting-context-provider'
import Content from 'modules/vesting/content'
import Header from 'modules/vesting/header'

const Vesting = () => {
  return (
    <VestingProvider type={VestingTypeEnum.VESTING}>
      <div className="main-section user">
        <Breadcrumb additionalItems={[BREADCRUMBS.VESTING]} />
        <Header />
        <Content />
      </div>
    </VestingProvider>
  )
}

export default Vesting
